import clsx from 'clsx';
import React from 'react';

type MosaicListItem = React.ReactElement | null | false;

export type MosaicListProps = Readonly<{
  ariaLabel?: string;
  ariaLabelledBy?: string;
  as?: 'ol' | 'ul';
  columns?: 2 | 3 | 4;
  items?: MosaicListItem[];
}>;

function isRenderableItem(item: MosaicListItem): item is React.ReactElement {
  return Boolean(item);
}

function MosaicList({
  ariaLabel,
  ariaLabelledBy,
  as: Component = 'ul',
  columns = 4,
  items = [],
}: MosaicListProps): JSX.Element {
  // ClassRoomCard concatena un null cuando no hay tarjeta «Añadir curso»: sin este filtro salía
  // un <li> vacío que el lector de pantalla contaba como un elemento más de la lista (TAN-11138).
  const renderableItems = items.filter(isRenderableItem);

  return (
    <Component
      aria-label={ariaLabel}
      aria-labelledby={ariaLabelledBy}
      className={clsx('mosaic-list', `mosaic-list--col-${columns}`)}
      role="list"
    >
      {renderableItems.map((item, i) => (
        <li key={item.key ?? i} className="mosaic-list__item">
          {item}
        </li>
      ))}
    </Component>
  );
}

export default MosaicList;
